module.exports = __webpack_public_path__ + "static/img/sm_demo.88198a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm_demo.png
// module id = vJrk
// module chunks = 1